import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { PermissionSystem } from 'src/app/Interfaces/hr/permission-system';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { DataShareService } from 'src/app/shared/services/data-share.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-add-edit-permission-header-work-system',
  templateUrl: './add-edit-permission-header-work-system.component.html',
  styleUrls: ['./add-edit-permission-header-work-system.component.scss']
})
export class AddEditPermissionHeaderWorkSystemComponent implements OnInit {
  ServerError$: Observable<any> = this.DataShareService.ServerError$;
  permissionname:string='';
  permissionheaderid:number;
  permissiondropdown:any=[]
  dataSource:any=[];
  button={}
  permissionData:PermissionSystem[]=[]
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;

  // loading
  loading:boolean=false

  constructor(public _publicSettingService:publicSettingService,public gt:genericCustomStoreService,public translate:TranslateService,
    public Objects:ObjectsService,private validation:CheckValidation,public router:Router,public DataShareService: DataShareService) { 
    gt.getdropdowndata("PermissionType").subscribe(res=>this.permissiondropdown=res)
    this.button=Objects.button;
    this.setCellValuepermission=this.setCellValuepermission.bind(this)
    this.validateAsync = this.validateAsync.bind(this);
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });
    //update
    this._publicSettingService.$PERMISSION_ID.subscribe(res=>this.permissionheaderid=res)
    if(this.permissionheaderid!=0){
      this.loading=true;
      _publicSettingService.byKey("PermissionHeaderWorkSystem",this.permissionheaderid).subscribe((res:PermissionSystem)=>{
        this.dataSource=res.rules
        this.permissionname=res.nameAr
        this.loading=false;
      })
    }
    else{
      gt.getdropdowndata("PermissionHeaderWorkSystem","GetEmptyRecord").subscribe((res:{rules:{}[]})=>this.dataSource=res.rules)
    }
  }

  ngOnInit(): void {
    debugger
    this.DataShareService.removeServerError()
  }

  validateAsync (params:any) {
    var id = this.permissionheaderid;
    return this.validation.asyncCheckNameValue(params.value,id,"PermissionHeaderWorkSystem");
    
  }

  setCellValuepermission(newData:any, value:any){
    newData.permissionTypeId=value;
    this.permissiondropdown.filter((ele:any)=>{
      ele.id==value? newData.duration= ele.duration:''      
    })
  }

  onInitNewRow(e:any){
    e.data.id=0;
    e.data.permissionHeaderWorkSystemId=this.permissionheaderid;
  }

  onFormSubmit(e:any){
    this.permissionData=[
      {
      id:this.permissionheaderid,
      nameAr:this.permissionname,
      rules:this.dataSource
    }
  ]
  if(this.permissionheaderid!=0){
    this._publicSettingService.update("PermissionHeaderWorkSystem",this.permissionData[0]).subscribe(res=>{
      this._publicSettingService.$PERMISSION_ReFRESH.next(true)
      this.router.navigate(['hr/PermissionHeaderWorkSystem']) 
    })
     
  }
  else{
    this._publicSettingService.add("PermissionHeaderWorkSystem",this.permissionData[0]).subscribe(res=>{
      this._publicSettingService.$PERMISSION_ReFRESH.next(true)
      this.router.navigate(['hr/PermissionHeaderWorkSystem']) 
    })
  }
  }
  // backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/PermissionHeaderWorkSystem'])
  //   }
  // }

}
